import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';

export default function ContactForm() {
    const [isMounted, didMount] = useState(false)
    const [loading, setLoading] = useState(true)

    //form data
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    })

    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')

    useEffect(()=>{
        didMount(true)
    }, [])
    
    useEffect(()=>{
        if (isMounted) {
            setLoading(false)
        }
    }, [isMounted])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('')
        setSuccess('')
        setLoading(true)

        try {
            if (formData.name != '' && formData.email != '' && formData.subject != '' && formData.message != '') {
                const response = await axios.post('/email/contact-us-form', formData);
                if (response.data.success) {
                    setSuccess('Email was sent successfully sent. We will get back to you as soon as possible.')
                    // Reset form after successful submission
                    setFormData({
                        name: '',
                        email: '',
                        subject: '',
                        message: ''
                    })
                } else {
                    setError(response.data.message || 'An error occurred while sending the message. Please try again later.')
                }
            }
        } catch (error) {
            setError('An error occurred while sending the message. Please try again later or email us directly at csam.scma@gmail.com')
        } finally {
            setTimeout(() => {
                if (isMounted) {
                    setLoading(false)
                }
            }, 1500)
        }
    }

    if (loading) return (
        <div className="nasa-featured-news">
            <Row className="justify-content-center">
                <Col xs={12}>
                    <Card className="nasa-style-card" style={{ border: 'none' }}>
                        <Card.Body style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Spinner animation="border" role="status" style={{ width: '2rem', height: '2rem', color: '#0b3d91' }} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )

   if (!loading) return (
        <div className="nasa-featured-news">
            <Row className="justify-content-center">
                <Col xs={12} sm={10} md={8}>
                    <Card className="nasa-style-card" style={{ border: 'none' }}>
                        <Card.Header style={{
                            background: 'transparent',
                            border: 'none',
                            borderBottom: '1px solid #e6e6e6',
                            padding: '1.5rem 2rem 1rem 2rem',
                            marginBottom: '0'
                        }}>
                            <h2 style={{
                                fontSize: 'clamp(1.5rem, 4vw, 2rem)',
                                fontWeight: '700',
                                color: '#0b3d91',
                                margin: '0',
                                letterSpacing: '-0.02em',
                                lineHeight: '1.2'
                            }}>
                                Get in Touch
                            </h2>
                        </Card.Header>
                        <Card.Body style={{ padding: '2rem' }}>
                            {error && <Alert variant="danger" style={{ borderRadius: '8px', marginBottom: '1.5rem' }}>{error}</Alert>}
                            {success && <Alert variant="success" style={{ borderRadius: '8px', marginBottom: '1.5rem' }}>{success}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.5rem' }}>Name</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="name"
                                        placeholder="Enter your name" 
                                        value={formData.name}
                                        onChange={handleChange}
                                        style={{
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0',
                                            padding: '0.75rem 1rem',
                                            fontSize: '0.95rem',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = '#0b3d91'}
                                        onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        required 
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.5rem' }}>Email</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        name="email"
                                        placeholder="Enter your email" 
                                        value={formData.email}
                                        onChange={handleChange}
                                        style={{
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0',
                                            padding: '0.75rem 1rem',
                                            fontSize: '0.95rem',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = '#0b3d91'}
                                        onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        required 
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.5rem' }}>Subject</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="subject"
                                        placeholder="Enter the subject of your message" 
                                        value={formData.subject}
                                        onChange={handleChange}
                                        style={{
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0',
                                            padding: '0.75rem 1rem',
                                            fontSize: '0.95rem',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = '#0b3d91'}
                                        onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        required 
                                    />
                                </Form.Group>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '0.5rem' }}>Message</Form.Label>
                                    <Form.Control 
                                        name="message"
                                        as="textarea" 
                                        rows={5} 
                                        placeholder="Enter your message" 
                                        value={formData.message}
                                        onChange={handleChange}
                                        style={{
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0',
                                            padding: '0.75rem 1rem',
                                            fontSize: '0.95rem',
                                            resize: 'vertical',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = '#0b3d91'}
                                        onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        required 
                                    />
                                </Form.Group>
                                <Button 
                                    type="submit" 
                                    variant="primary" 
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 1.5rem',
                                        borderRadius: '8px',
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        background: 'linear-gradient(135deg, #0b3d91 0%, #4dacff 100%)',
                                        border: 'none',
                                        boxShadow: '0 4px 12px rgba(11,61,145,0.3)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 6px 16px rgba(11,61,145,0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 12px rgba(11,61,145,0.3)';
                                    }}
                                >
                                    Send Message
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
  );
}